export const ACCOUNT_EVENT_IDS = {
  DEPOSIT_REQUIRED: 'event.deposit.required',
  RECOVER_REQUESTED: 'event.account.recovery.requested',
  REOPEN_REQUESTED: 'event.account.reopen.requested',
  RESET_PASSWORD_REQUIRED: 'event.account.password.reset.required',
  FAQ_PAGE_REQUESTED: 'event.faq.page.requested',
  LIVE_CHAT_REQUESTED: 'event.live.chat.requested',
  LOGIN_REQUESTED: 'event.account.login.requested',
  REGISTRATION_REQUESTED: 'event.account.registration.requested',
  MYACCOUNT_START_REQUESTED: 'event.account.myaccount.start.requested',
  MYACCOUNT_CANCEL_REQUESTED: 'event.account.myaccount.cancel.requested',
  SAFER_GAMBLING_MODALS_START_REQUESTED: 'event.account.safer.gambling.modals.start.requested',
  HARD_FLAG_REQUESTED: 'event.account.hard.flag.requested',
  SOFT_FLAG_REQUESTED: 'event.account.soft.flag.requested',
  ACCOUNT_FLAG_CLOSE_REQUESTED: 'event.account.flag.close.requested',
  ACCOUNT_FLAG_SUCCESS_REQUESTED: 'event.account.flag.success.requested',
  ACCOUNT_FLAG_QUIT_REQUESTED: 'event.account.flag.quit.requested',
  CONTACT_VERIFICATION_RESOLVED: 'event.account.hard.flag.contactverification.resolved',
  OB_DEPOSIT_REQUESTED: 'event.obDeposit.requested',
  NATIVE_EXTERNAL_PAGE_REQUESTED: 'event.native.external.page.requested',
  NATIVE_DOCUMENT_UPLOAD_REQUESTED: 'event.native.document.upload.requested',

  API_CALL_INVALID: 'event.account.api.call.invalid',
  INVALID_STATE: 'event.account.state.invalid',
  OPERATION_FAILED: 'event.account.operation.failed',

  WELCOME_MESSAGES_REQUESTED: 'event.wm.campaign.requested',
  WELCOME_MESSAGES_CAMPAIGN_DISPLAYED: 'event.wm.campaign.displayed',
  WELCOME_MESSAGES_NAVIGATE_REQUESTED: 'event.wm.navigate.requested',
  WELCOME_MESSAGES_OPTIN_REQUESTED: 'event.wm.optin.requested',
  BETSLIP_REQUESTED: 'event.betslip.requested',
  PLACE_BET_REQUESTED: 'event.place.bet.requested',
  LAUNCH_GAME_REQUESTED: 'event.launch.game.requested',
};
